/* SHOP AFRICA USA — Product gallery containment, slider, zoom, and card previews */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function clampIndex(index, total) {
    if (!total) return 0;
    return (index + total) % total;
  }

  function makeButton(className, label, html) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = className;
    btn.setAttribute('aria-label', label);
    btn.innerHTML = html;
    return btn;
  }

  function getImageSrc(img) {
    if (!img) return '';
    return img.currentSrc || img.getAttribute('src') || '';
  }

  function initProductPageGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery || gallery.__proGalleryReady) return;
    gallery.__proGalleryReady = true;

    var main = gallery.querySelector('.pgallery__main');
    var images = Array.prototype.slice.call(gallery.querySelectorAll('[data-gimg]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gthumb]'));
    if (!main || !images.length) return;

    var activeIndex = Math.max(0, images.findIndex(function (img) { return img.classList.contains('is-active'); }));
    if (activeIndex < 0) activeIndex = 0;

    function setActive(index) {
      activeIndex = clampIndex(index, images.length);
      images.forEach(function (img, i) {
        img.classList.toggle('is-active', i === activeIndex);
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === activeIndex);
        thumb.setAttribute('aria-current', i === activeIndex ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { setActive(i); });
    });

    if (images.length > 1 && !main.querySelector('[data-gallery-prev]')) {
      var prev = makeButton('pgallery__control pgallery__control--prev', 'Previous product image', '‹');
      var next = makeButton('pgallery__control pgallery__control--next', 'Next product image', '›');
      prev.setAttribute('data-gallery-prev', '');
      next.setAttribute('data-gallery-next', '');
      main.appendChild(prev);
      main.appendChild(next);
      prev.addEventListener('click', function () { setActive(activeIndex - 1); });
      next.addEventListener('click', function () { setActive(activeIndex + 1); });
    }

    var zoom = makeButton('pgallery__zoom', 'Open product image zoom', 'Zoom');
    zoom.setAttribute('data-gallery-zoom', '');
    if (!main.querySelector('[data-gallery-zoom]')) main.appendChild(zoom);

    var lightbox = document.querySelector('[data-pgallery-lightbox]');
    if (!lightbox) {
      lightbox = document.createElement('div');
      lightbox.className = 'pgallery-lightbox';
      lightbox.setAttribute('data-pgallery-lightbox', '');
      lightbox.innerHTML = '<div class="pgallery-lightbox__stage" role="dialog" aria-modal="true" aria-label="Product image zoom"><button type="button" class="pgallery-lightbox__close" aria-label="Close image zoom">×</button><button type="button" class="pgallery-lightbox__nav pgallery-lightbox__prev" aria-label="Previous image">‹</button><img class="pgallery-lightbox__img" alt=""><button type="button" class="pgallery-lightbox__nav pgallery-lightbox__next" aria-label="Next image">›</button><span class="pgallery-lightbox__caption"></span></div>';
      document.body.appendChild(lightbox);
    }

    var lbImg = lightbox.querySelector('.pgallery-lightbox__img');
    var lbCaption = lightbox.querySelector('.pgallery-lightbox__caption');
    var lbClose = lightbox.querySelector('.pgallery-lightbox__close');
    var lbPrev = lightbox.querySelector('.pgallery-lightbox__prev');
    var lbNext = lightbox.querySelector('.pgallery-lightbox__next');

    function updateLightbox() {
      var img = images[activeIndex];
      lbImg.src = getImageSrc(img);
      lbImg.alt = img.getAttribute('alt') || 'Product image';
      lbImg.classList.remove('is-zoomed');
      lbCaption.textContent = (activeIndex + 1) + ' / ' + images.length + ' — click image to zoom';
      lbPrev.style.display = images.length > 1 ? '' : 'none';
      lbNext.style.display = images.length > 1 ? '' : 'none';
    }

    function openLightbox() {
      updateLightbox();
      lightbox.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      lbClose.focus();
    }

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      lbImg.classList.remove('is-zoomed');
    }

    zoom.addEventListener('click', openLightbox);
    images.forEach(function (img) {
      img.addEventListener('dblclick', openLightbox);
    });
    lbClose.addEventListener('click', closeLightbox);
    lbPrev.addEventListener('click', function () { setActive(activeIndex - 1); updateLightbox(); });
    lbNext.addEventListener('click', function () { setActive(activeIndex + 1); updateLightbox(); });
    lbImg.addEventListener('click', function () { lbImg.classList.toggle('is-zoomed'); });

    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox) closeLightbox();
    });

    document.addEventListener('keydown', function (event) {
      if (lightbox.classList.contains('is-open')) {
        if (event.key === 'Escape') closeLightbox();
        if (event.key === 'ArrowLeft') { setActive(activeIndex - 1); updateLightbox(); }
        if (event.key === 'ArrowRight') { setActive(activeIndex + 1); updateLightbox(); }
      }
    });

    var startX = null;
    [main, lightbox].forEach(function (el) {
      el.addEventListener('touchstart', function (event) {
        if (event.touches && event.touches.length) startX = event.touches[0].clientX;
      }, { passive: true });
      el.addEventListener('touchend', function (event) {
        if (startX === null || !event.changedTouches || !event.changedTouches.length) return;
        var dx = event.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) < 45) return;
        setActive(activeIndex + (dx < 0 ? 1 : -1));
        if (lightbox.classList.contains('is-open')) updateLightbox();
      }, { passive: true });
    });

    setActive(activeIndex);
  }

  function initProductCardGalleries() {
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-pcard-gallery]'));
    cards.forEach(function (card) {
      if (card.__cardGalleryReady) return;
      card.__cardGalleryReady = true;

      var images = Array.prototype.slice.call(card.querySelectorAll('[data-card-img]'));
      var thumbs = Array.prototype.slice.call(card.querySelectorAll('[data-card-thumb]'));
      var prev = card.querySelector('[data-card-prev]');
      var next = card.querySelector('[data-card-next]');
      var index = 0;
      if (!images.length) return;

      function setCardImage(nextIndex) {
        index = clampIndex(nextIndex, images.length);
        images.forEach(function (img, i) { img.classList.toggle('is-active', i === index); });
        thumbs.forEach(function (thumb, i) {
          thumb.classList.toggle('is-active', i === index);
          thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          setCardImage(i);
        });
      });

      if (prev) {
        prev.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          setCardImage(index - 1);
        });
      }
      if (next) {
        next.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          setCardImage(index + 1);
        });
      }

      setCardImage(0);
    });
  }

  ready(function () {
    initProductPageGallery();
    initProductCardGalleries();

    document.addEventListener('shopify:section:load', function () {
      initProductPageGallery();
      initProductCardGalleries();
    });
  });
})();
